import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class LoginGuard  {
  constructor(
    private toastrService: ToastrService,
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkLogin(state.url);
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkLogin(state.url);
  }

  canLoad(route: Route): boolean {
    let usePath = window.location.hash;
    if (usePath.length) {
      usePath = usePath.substring(1);
    } else {
      usePath = route.path;
    }
    return this.checkLogin(usePath);
  }

  checkLogin(url: string): boolean {
    if (!this.authService.isLoggedIn()) {
      this.toastrService.error('You must log in to access this page');
      if (url.indexOf('login') <= 0) {
        localStorage.setItem('redirectUrl', url);
      }
      this.router.navigate(['/login']);
      return false;
    } else {
      return true;
    }
  }
}
